import { render, staticRenderFns } from "./ComponentGoods.vue?vue&type=template&id=496419c6&"
import script from "./ComponentGoods.vue?vue&type=script&lang=js&"
export * from "./ComponentGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports